import { useNavigate } from "react-router-dom";

import PromotionList from "../../features/promotion/promotionList";
import SearchBar from "../../components/SearchBar";
import { useState } from "react";
import { Button } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import usePermission from "../../hooks/usePermission";

const ManageCategories = () => {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");
  const [debounceSearchTerm, setDebounceSearchTerm] = useState("");
  const { isAdd } = usePermission({
    label: "Manage Product Categories",
    page_permission: "isView",
  });

  return (
    <>
      <div className="main_title">
        <h1>Manage Product Categories</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button> -
          Manage Product Categories
        </p>
      </div>
      <div className="cards">
        <div className="table_header">
          <div className="left_s">
            <SearchBar
              searchTerm={searchTerm}
              setSearchTerm={setSearchTerm}
              setDebouncedSearchTerm={setDebounceSearchTerm}
              placeholder="Search..."
            />
          </div>
          {isAdd && (
            <div className="right_s">
              <Button
                className="btn btn_primary"
                onClick={() => navigate("/manage-categories/add")}
              >
                <AddIcon /> Add Category
              </Button>
            </div>
          )}
        </div>
        <PromotionList search={debounceSearchTerm} />
      </div>
    </>
  );
};

export default ManageCategories;
